const { getOffsetTop } = window.BAO.Utils

class StickyScroll extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!window.innerWidth > 901) return

    this.isTicking = false
    this.lastKnownY = window.scrollY
    this.scrollDirection = ''
    this.scrollDirectionPrevious = ''

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()
  }

  setupListeners () {
    super.setupListeners()

    if (!window.innerWidth > 901) return

    this.onScroll = this.onScroll.bind(this)

    this.listeners.add(window, 'scroll', this.onScroll)

    this.listeners.add(
      this,
      'BEFORE_ACCORDION_ANIMATION',
      this.setHeight.bind(this),
    )
    this.listeners.add(
      this,
      'AFTER_ACCORDION_ANIMATION',
      this.setSticky.bind(this),
    )
  }

  onScroll () {
    const previouslyKnown = this.lastKnownY
    this.scrollDirectionPrevious = this.scrollDirection

    this.lastKnownY = window.scrollY
    this.scrollDirection = previouslyKnown < this.lastKnownY ? 'down' : 'up'

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.setSticky()
  }

  setHeight () {
    if (!this.els?.content?.element) return

    this.els.content.element.style.setProperty(
      'height',
      `${this.contentHeight}px`,
    )
  }

  setSticky () {
    this.els?.content?.element?.style?.removeProperty('height')

    const containerHeight = this.els.container.element.offsetHeight

    if (this.viewportHeight > this.contentHeight) {
      this.els.spacer.element.style.removeProperty('margin-top')
    }

    if (
      containerHeight > this.contentHeight &&
      window.innerHeight < this.contentHeight
    ) {
      this.classList.toggle('prd-Detail_Columns-defaultSticky', false)

      const offsetAmount = window.innerHeight - this.contentHeight

      if (this.scrollDirectionPrevious !== this.scrollDirection) {
        const containerOffsetTop = getOffsetTop(this.els.container.element)
        const contentOffsetTop = getOffsetTop(this.els.content.element)

        this.els.spacer.element.style.setProperty(
          'margin-top',
          `${contentOffsetTop - containerOffsetTop}px`,
        )
      }

      if (this.scrollDirection === 'down') {
        this.els.content.element.style.setProperty('top', `${offsetAmount}px`)
        this.els.content.element.style.removeProperty('bottom')
      } else {
        const announcementBar = document.querySelector(
          'header-announcement-bar',
        )
        const announcementBarHeight =
          announcementBar !== null ? announcementBar.offsetHeight : 0
        const headerEl = document.querySelector('.hd-Header')
        const headerHeight = headerEl?.offsetHeight || 0
        const combinedHeight = announcementBarHeight + headerHeight

        this.els.content.element.style.setProperty(
          'bottom',
          `calc(${offsetAmount}px - ${combinedHeight}px`,
        )
      }
    } else {
      this.classList.toggle('prd-Detail_Columns-defaultSticky', true)
      this.els.content.element.style.removeProperty('top')
      this.els.content.element.style.removeProperty('bottom')
      this.els.spacer.element.style.removeProperty('top')
    }
  }

  get viewportHeight () {
    return Math.max(
      document.documentElement.clientHeight || 0,
      window.innerHeight || 0,
    )
  }

  get contentHeight () {
    return (
      this.els?.content?.element?.getBoundingClientRect()?.height ||
      this.getBoundingClientRect()?.height
    )
  }
}

if (!customElements.get('sticky-scroll')) {
  customElements.define('sticky-scroll', StickyScroll)
}
